import { Checkbox, CheckboxProps } from "@chakra-ui/react";
import { getPrefixedId } from "components/Shared/FilterEditor/createNestedFilterDefinitions";
import type { AppliedFilter } from "components/Shared/FilterEditor/utils";

export const INCLUDE_CUSTOM_FILTER_NAME = "includeCustom";

export function getValueFromFilters(filters: AppliedFilter[], prefix?: string) {
  const appliedFilter = filters.find(
    (f) => f.filter === getPrefixedId(prefix, INCLUDE_CUSTOM_FILTER_NAME),
  );

  if (!appliedFilter) return true;

  if (typeof appliedFilter.value !== "boolean") return;

  if (appliedFilter.variant === "equalTo") {
    return appliedFilter.value;
  }

  if (appliedFilter.variant === "notEqualTo") {
    return !appliedFilter.value;
  }
}

export function makeFiltersHandleChange(
  existingFilters: AppliedFilter[],
  handleFiltersChange: (filters: AppliedFilter[]) => void,
  prefix?: string,
) {
  const filterId = getPrefixedId(prefix, INCLUDE_CUSTOM_FILTER_NAME);
  return (value: boolean) => {
    const otherFilters = existingFilters.filter((f) => f.filter !== filterId);
    handleFiltersChange([
      ...otherFilters,
      {
        filter: filterId,
        value,
        variant: "equalTo",
      },
    ]);
  };
}

type Props = Omit<CheckboxProps, "onChange"> & {
  onChange?: (isChecked: boolean) => void;
};

export default function IncludeCustomFilter({
  isChecked,
  isIndeterminate,
  onChange,
  ...rest
}: Props) {
  return (
    <Checkbox
      size="sm"
      isChecked={isChecked}
      isIndeterminate={isIndeterminate || typeof isChecked !== "boolean"}
      onChange={(e) => onChange?.(e.target.checked)}
      {...rest}
    >
      Include Custom?
    </Checkbox>
  );
}
